import { CrewErrorBoundary } from 'components/functions/crewErrorBoundary'
import { FC, memo } from 'react'
import { AnnouncementList } from './components/announcementList/announcementList'
import { AnnouncementHeader } from './components/announcementHeader/announcementHeader'

export const AnnouncementPage: FC = memo(() => {
  return (
    <>
      {/** 上部のチェックボックス */}
      <CrewErrorBoundary>
        <AnnouncementHeader />
      </CrewErrorBoundary>
      {/** お知らせ一覧 */}
      <CrewErrorBoundary>
        <AnnouncementList />
      </CrewErrorBoundary>
    </>
  )
})
